var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"dir":_vm.lang === 'ar' ? 'rtl' : 'ltr'}},[(_vm.status)?_c('LoginPage',{on:{"user-token":_vm.userToken}}):_c('UserContent',{attrs:{"user-logout":_vm.userLogout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }